export const dummyDataGuidelines = 'some dummy guidelines..........';
